import {useRoutes, useNavigate } from "react-router-dom";
import { Suspense, lazy,  Space, Spin } from 'react'
import { LoadingOutlined } from '@ant-design/icons';

export const routes = [
  {
    path: '/',
    auth:false,
    component:lazy(() => import('../pages/Login'))
  },
  // {
  //   path: '/dashboard',
  //   auth:true,
  //   component:lazy(() => import('../pages/dashboard'))
  // },
  // 在home下进入layout内容
  {
    path: '/home',
    auth:true,
    component:lazy(() => import('../pages/home')),
    children: [
      {
        path: '/home/dashboard',
        auth:true,
        component:lazy(() => import('../compontens/Dashboard/index'))
      },
      {
        path: '/home/product',
        auth:true,
        component:lazy(() => import('../compontens/Product/index'))
      },
      {
        path: '/home/product/newProduct',
        auth:true,
        component:lazy(() => import('../compontens/Product/NewProduct/index'))
      },
      {
        path: '/home/product/productDevelopment',
        auth:true,
        component:lazy(() => import('../compontens/Product/ProductDevelopment/index'))
      },
      {
        path: '/home/product/productConsumables',
        auth:true,
        component:lazy(() => import('../compontens/Product/ProductConsumables/index'))
      },
      {
        path: '/home/product/messagePush',
        auth:true,
        component:lazy(() => import('../compontens/Product/MessagePush/index'))
      },
      {
        path: '/home/product/distributionNetwork',
        auth:true,
        component:lazy(() => import('../compontens/Product/DistributionNetwork/index'))
      },
      {
        path: '/home/product/voicePacketManagement',
        auth:true,
        component:lazy(() => import('../compontens/Product/VoicePacketManagement/index'))
      },
      {
        path: '/home/product/multilingual',
        auth:true,
        component:lazy(() => import('../compontens/Product/Multilingual/index'))
      },
      {
        path: '/home/product/knowledgeBase',
        auth:true,
        component:lazy(() => import('../compontens/Product/KnowledgeBase/index'))
      },
      {
        path: '/home/product/KnowledgeVideo',
        auth: true,
        component:lazy(() => import('../compontens/Product/KnowledgeVideo/index'))
      },
      {
        path: '/home/product/productManual',
        auth:true,
        component:lazy(() => import('../compontens/Product/ProductManual/index'))
      },
      {
        path: '/home/product/firmwareOTA',
        auth:true,
        component:lazy(() => import('../compontens/Product/FirmwareOTA/index'))
      },
      {
        path: '/home/product/deviceManagement',
        auth:true,
        component:lazy(() => import('../compontens/Product/DeviceManagement/index'))
      },
      {
        path: '/home/productDetails',
        auth:true,
        component:lazy(() => import('../compontens/ProductDetails/index'))
      },
      {
        path: '/home/productKnowledgeCreation',
        auth:true,
        component:lazy(() => import('../compontens/ProductKnowledgeCreation/index'))
      },
      {
        path: '/home/knowledgeCreation',
        auth:true,
        component:lazy(() => import('../compontens/KnowledgeCreation/index'))
      },
      {
        path: '/home/voicepacketMarket',
        auth:true,
        component:lazy(() => import('../compontens/VoicepacketMarket/index'))
      },
      {
        path: '/home/serviceDetails',
        auth:true,
        component:lazy(() => import('../compontens/ServiceDetails/index'))
      },
      {
        path: '/home/activateNow',
        auth:true,
        component:lazy(() => import('../compontens/ActivateNow/index'))
      },
      {
        path: '/home/shelfServiceAll',
        auth:true,
        component:lazy(() => import('../compontens/ShelfServiceAll/index'))
      },
      {
        path: '/home/product/editProductKnowledge',
        auth:true,
        component:lazy(() => import('../compontens/Product/EditProductKnowledge/index'))
      },
      {
        path: '/home/product/productKnowledge',
        auth:true,
        component:lazy(() => import('../compontens/Product/ProductKnowledge/index'))
      },
      {
        path: '/home/product/pIDKnowledge',
        auth:true,
        component:lazy(() => import('../compontens/Product/PIDKnowledge/index'))
      },
      {
        path: '/home/accountAuthentication',
        auth:true,
        component:lazy(() => import('../compontens/AccountAuthentication/index'))
      },
      {
        path: '/home/app',
        auth:true,
        component:lazy(() => import('../compontens/APP/index'))
      },
      {
        path: '/home/app/appDevelopment',
        auth:true,
        component:lazy(() => import('../compontens/APP/AppDevelopment/index'))
      },
      {
        path: '/home/app/shelfConfiguration',
        auth:true,
        component: lazy(() => import('../compontens/APP/ShelfConfiguration/index')),
        // children: [
        //   {
        //     path: '/home/app/shelfConfiguration/yinsi',
        //     auth:true,
        //     component: lazy(() => import('../compontens/APP/ShelfConfiguration/index')),
        //   }
        // ]
      },
      {
        path: '/home/app/optionalConfiguration',
        auth:true,
        component:lazy(() => import('../compontens/APP/OptionalConfiguration/index'))
      },
      {
        path: '/home/app/developmentTool',
        auth:true,
        component:lazy(() => import('../compontens/APP/DevelopmentTool/index'))
      },
      {
        path: '/home/product/developmentTool',
        auth:true,
        component:lazy(() => import('../compontens/Product/DevelopmentTool/index'))
      },
      {
        path: '/home/product/screenConfiguration',
        auth:true,
        component:lazy(() => import('../compontens/Product/ScreenConfiguration/index'))
      },
      {
        path: '/home/app/multilingualManagement',
        auth:true,
        component:lazy(() => import('../compontens/APP/MultilingualManagement/index'))
      },
      {
        path: '/home/app/maintenanceManage',
        auth:true,
        component:lazy(() => import('../compontens/APP/MaintenanceManage/index'))
      },
      {
        path: '/home/app/addressLibrary',
        auth:true,
        component:lazy(() => import('../compontens/APP/AddressLibrary/index'))
      },
      {
        path: '/home/operate/discoveryPlate',
        auth: true,
        component: lazy(() => import('../compontens/Operate/DiscoveryPlate/index')),
      },
      {
        path: '/home/operate/customerManaging',
        auth: true,
        component: lazy(() => import('../compontens/Operate/CustomerManaging/index')),
      },
      {
        path: '/home/operate/messageBox',
        auth: true,
        component: lazy(() => import('../compontens/Operate/MessageBox/index')),
      },
      {
        path: '/home/operate/userFeedback',
        auth: true,
        component: lazy(() => import('../compontens/Operate/UserFeedback/index')),
      },
      {
        path: '/home/operate/advertisingPush',
        auth: true,
        component: lazy(() => import('../compontens/Operate/AdvertisingPush/index')),
      }
    ]
  },
  // 问卷调查填写
  {
    path: '/EditQuestionnaire',
    auth:false,
    component:lazy(() => import('../compontens/Operate/EditQuestionnaire/index'))
  },
  // 回收量看板
  {
    path: './RecyclingDashboard',
    auth: false,
    component:lazy(() => import('../compontens/Operate/RecyclingDashboard/index'))
  },
  // {
  //   path: '/app',
  //   auth:true,
  //   component:lazy(() => import('../pages/homeAPP')),
  //   children: [
  //     {
  //       path: '/app/index',
  //       auth:true,
  //       component:lazy(() => import('../compontens/APP/index'))
  //     },
  //     {
  //       path: '/app/appDevelopment',
  //       auth:true,
  //       component:lazy(() => import('../compontens/APP/AppDevelopment/index'))
  //     },
  //   ]
  // },
  {
    path: '/DocumentCenter',
    auth:false,
    component:lazy(() => import('../pages/DocumentCenter'))
  },
  {
    path: '/DetailedConfiguration',
    auth:false,
    component:lazy(() => import('../compontens/APP/DetailedConfiguration/index'))
  },
  {
    path: '/TechnicalSupport',
    auth:false,
    component:lazy(() => import('../compontens/TechnicalSupport'))
  },
  {
    path: '/NewWorkOrder',
    auth:false,
    component:lazy(() => import('../compontens/TechnicalSupport/NewWorkOrder'))
  },
  {
    path: '/WorkOrderDetails',
    auth:false,
    component:lazy(() => import('../compontens/TechnicalSupport/WorkOrderDetails'))
  },
  
  // {
  //   path: '*',
  //   auth:false,
  //   component:lazy(() => import('../page/error/NotFound'))
  // }
]


/**
 * 根据路径获取路由
 * */
const checkAuth = (routers, path)=>{
  for (const data of routers) {
    if (data.path===path) return data
    if (data.children) {
      const res = checkAuth(data.children, path)
      if (res) return res
    }
  }
  return null
}
 
/**
 * 路由处理方式
 * */ 
const generateRouter = (routers) => {
  
    return routers.map((item) => {
      if (item.children) {
        item.children = generateRouter(item.children)
      }
      item.element = <Suspense fallback={
        <div direction="vertical"
          style={{ width: '100%', height: '100vh', lineHeight:'30%', textAlign: 'center', color: '#024CFF' }}>
         <LoadingOutlined></LoadingOutlined>  加载中...
          </div>
      }>
        {/* 把懒加载的异步路由变成组件装载进去 */}
        <item.component />
      </Suspense>
      return item
    })
 
 
}
 
const Router = () => useRoutes(generateRouter(routes))
const checkRouterAuth = (path) => {
  let auth = null
  auth = checkAuth(routes,path)
  return auth
}
export{ Router,checkRouterAuth }